module.exports = __webpack_public_path__ + "static/media/8.310c588e.jpg";